import React from 'react';
import PropTypes from 'prop-types';
//components
import TitleMain from './titleMain';
import Colors from './colors';
//img
import consumables__img from '../assets/img/consumables_img.jpg';
//css
import '../assets/css/consumables.css';

class Consumables extends React.Component {
  render () {
    return(
      <div className="Consumables">
        <TitleMain name='打印耗材'/>
        <img src={consumables__img} alt="consumables__img" className="Consumables__img" width='100%'/>
        <div className='Consumables__title'>
          <ul className='Consumables__list'>
            <li className='Consumables-list__item'>材料</li>
            <li className='Consumables-list__item'>重量／密度</li>
            <li className='Consumables-list__item'>熔点</li>
            <li className='Consumables-list__item'>溶体流动指数</li>
            <li className='Consumables-list__item'>拉伸屈服强度</li>
            <li className='Consumables-list__item'>断裂延伸度</li>
            <li className='Consumables-list__item'>弯曲强度</li>
            <li className='Consumables-list__item'>弯曲模量</li>
            <li className='Consumables-list__item'>缺口冲击强度</li>
            <li className='Consumables-list__item'>支持打印方式</li>
            <li className='Consumables-list__item'>热变形温度</li>
            <li className='Consumables-list__item'>打印温度</li>
            <li className='Consumables-list__item'>底板要求温度</li>
            <li className='Consumables-list__item'>可选颜色</li>
          </ul>
        </div>
        <div className="Consumables__content">
          <ul className='Consumables__list'>
            <li className='Consumables-list__item'>PLA</li>
            <li className='Consumables-list__item'>1.0KG/卷 1.24g/cm³</li>
            <li className='Consumables-list__item'>180°C</li>
            <li className='Consumables-list__item'>7.8g/19min</li>
            <li className='Consumables-list__item'>62.63MPa</li>
            <li className='Consumables-list__item'>4.43%</li>
            <li className='Consumables-list__item'>65.02Mpa</li>
            <li className='Consumables-list__item'>2504.4MPa</li>
            <li className='Consumables-list__item'>4.28KJ/m²</li>
            <li className='Consumables-list__item'>打印机／打印笔</li>
            <li className='Consumables-list__item'>50°C</li>
            <li className='Consumables-list__item'>190-230°C</li>
            <li className='Consumables-list__item'>50°C</li>
            <li className='Consumables-list__item'>
              <Colors colors={['#000','#fc5b71','#e265a4','#695335','#896daa','#7a7b77','#8a8a88','#A91E1F','#422D28','#EFEFEF','#FB9648','#1E46A7','#AFC53C','#2A110E','#175A2D','#D2956B']}/>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default Consumables;
